export default ({ r, g, b, a }) => {
  const p = (s) => {
    s = s.toString(16);
    return s.length === 1 ? "0" + s : s;
  };
  return `#${p(parseInt(r * 255))}${p(parseInt(g * 255))}${p(
    parseInt(b * 255)
  )}${a < 1 ? p(parseInt(a * 255)) : ""}`;
};
